import { render } from "./OurPartnersProductPage.vue?vue&type=template&id=79aae9f6"
import script from "./OurPartnersProductPage.vue?vue&type=script&lang=js"
export * from "./OurPartnersProductPage.vue?vue&type=script&lang=js"

import "./OurPartnersProductPage.vue?vue&type=style&index=0&id=79aae9f6&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__